import axios from "axios";
import { errorResponse, successResponse } from "@/api/interceptors";

const http = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL,
});

export const setToken = (token) => {
  http.defaults.headers.common["token"] = token;
};

http.interceptors.response.use(successResponse, errorResponse);

export default http;
